// Clerk configuration
export const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  console.warn('Warning: REACT_APP_CLERK_PUBLISHABLE_KEY is not set. Authentication will not work.');
}
